import React from 'react';

const BookingMethodSelector = ({ currentMode, onModeSelect }) => {
  return (
    <div className="method-selector-container">
      <div className="method-selector-header">
        <h2>Hvordan ønsker du at fortsætte?</h2>
        <p>Vælg den metode der passer bedst til dit behov</p>
      </div>

      <div className="method-cards-grid">
        <div
          className="method-card instant-booking"
          onClick={() => onModeSelect('instant')}
        >
          <div className="method-card-icon">
            <span>⚡</span>
          </div>
          <div className="method-card-content">
            <h3>Instant Booking</h3>
            <p>
              Få en fast pris med det samme. Bedst til standardopgaver der kræver hurtig afklaring og øjeblikkelig bekræftelse.
            </p>
          </div>
          <div className="method-card-footer">
            <span className="method-btn">Book med det samme</span>
          </div>
        </div>

        <div
          className="method-card receive-offers"
          onClick={() => onModeSelect('normal')}
        >
          <div className="method-card-icon">
            <span>📄</span>
          </div>
          <div className="method-card-content">
            <h3>Modtag Tilbud</h3>
            <p>
              Indhent uforpligtende tilbud fra flere vognmænd. Bedst til større eller komplekse opgaver, hvor du vil sammenligne priser.
            </p>
          </div>
          <div className="method-card-footer">
            <span className="method-btn">Hent uforpligtende tilbud</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingMethodSelector;
